export default "__VITE_ASSET__BLa6QXWi__"